import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Box } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';

interface Props {
  isOpen: boolean;
  id: string;
  shipmentId: string;
  count: string;
  sequenceNumber: string;
}

const PURCHASE_ALERT_STORAGE_KEY = 'purchaseOrderReceivedItemsAlert';

const ReceivedInventoryAlert: React.FC<Props> = ({
  isOpen: propIsOpen = false,
  id: orderId = '',
  count = 0,
  shipmentId = '',
  sequenceNumber = '',
}) => {
  const [isOpen, setIsOpen] = React.useState(propIsOpen);

  React.useEffect(() => {
    const targetAlertClass = document.getElementsByClassName(
      'received_inventory_alert'
    )[0] as HTMLElement;
    targetAlertClass?.classList.add('display_alert');

    const displayAlert = document.getElementsByClassName('display_alert');

    displayAlert[0]?.setAttribute('style', `display: ${isOpen ? 'table-cell' : 'none'}`);

    return () => {
      const displayAlertClass = document.querySelector('.display_alert');
      displayAlertClass?.classList.remove('display_alert');
    };
  }, [isOpen]);

  React.useEffect(() => {
    window.openPurchaseOrderNotification = (id, count, shipmentId, sequenceNumber) => {
      window.sessionStorage.setItem(
        PURCHASE_ALERT_STORAGE_KEY,
        JSON.stringify({ isOpen: true, id, count, shipmentId, sequenceNumber })
      );
    };
    window.sessionStorage.removeItem(PURCHASE_ALERT_STORAGE_KEY);
    return () => {
      // @ts-ignore
      window.openPurchaseOrderNotification = undefined;
    };
  }, []);

  const closeAlert = () => {
    setIsOpen(false);
  };

  const shipmentLink = `/?name=purchase.views.purchase&form_name=view&id=${orderId}&tab=shipment_history&shipment_id=${shipmentId}`;

  return (
    <Box mb={3} data-test="inventory-received-alert">
      {isOpen && (
        <Alert type="success" onClose={closeAlert}>
          <Text fontWeight="bold">
            <var>{count}</var> {Number(count) > 1 ? 'items' : 'item'} added to inventory and record
            created for PO #<var>{orderId}</var>, shipment #<var>{sequenceNumber}</var>.
          </Text>
          <Text>
            View{' '}
            <TextLink
              data-test="inventory-received-alert-url"
              href={shipmentLink}
              onClick={(e) => {
                e.preventDefault();
                window.navigateToContent(
                  'view',
                  'purchase.views.purchase',
                  orderId,
                  'shipment_history'
                );
                window.history.pushState(null, '', shipmentLink);
                window.history.changeState();
              }}
            >
              record of shipment
            </TextLink>{' '}
            in shipment history.
          </Text>
        </Alert>
      )}
    </Box>
  );
};

const RenderedComponent = createReactRenderer({
  component: ReceivedInventoryAlert,
  selector: '[data-react-root="ReceivedInventoryAlert"]',
});

export default ReceivedInventoryAlert;

history.onChangeState(
  [
    {
      name: ['purchase.views.purchase'],
      form_name: 'view',
      tab: 'main',
    },
  ],
  () => {
    let props = {} as Props;
    try {
      props = JSON.parse(window.sessionStorage.getItem(PURCHASE_ALERT_STORAGE_KEY) || '');
    } catch {
      //
    }
    RenderedComponent.mount({
      props,
    });
  },
  () => {
    RenderedComponent.unmount();
  }
);
